import { render } from "./BuyIMDReport.vue?vue&type=template&id=fe5a3bf8&scoped=true"
import script from "./BuyIMDReport.vue?vue&type=script&lang=js"
export * from "./BuyIMDReport.vue?vue&type=script&lang=js"

import "./BuyIMDReport.vue?vue&type=style&index=0&id=fe5a3bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5a3bf8"]])

export default __exports__